import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { saveAs } from 'file-saver';
import { finalize } from 'rxjs/operators';
import { ToastService } from 'src/app/core';
import {
    CandidateDocuments,
    DocumentType, ImmigrationDocument, LookupField
} from 'src/app/core/api.gen';
import { AuthService } from 'src/app/core/auth.service';
import { CommonService } from 'src/app/core/common.service';
import { DialogService } from 'src/app/core/dialog.service';
import { DocumentUploadService } from 'src/app/core/document-upload.service';
import { LoaderService } from 'src/app/core/loader.service';
import { OpenFilePreviewService } from 'src/app/core/open-file-preview.service';
import { ImmigrationDataPopulationService } from 'src/app/immigration/services/data-population/ImmigrationDataPopulation.service';
import { nullSafe } from 'src/app/utils';
import { textEllipsis } from 'src/app/utils/helper-text';
import { Logger } from 'src/app/utils/Logger';
import { isNullOrUndefined } from '../../../app/core/utils';
import { ShareDocumentService } from '../../core/share-document.service';
import { GeneralMail } from '../configurable-mail/general-mail-model';
import { ModuleTypes } from '../module-types';
import { DocumentInstructions, EmailApi, ExitApi, ExitDocument, ExitRequest } from './../../core/api.gen';
import { ExitDocTypes } from './doc-types';

@Component({
  selector: 'eos-exit-file-upload',
  templateUrl: './exit-file-upload.component.html',
  styleUrls: ['./file-upload.component.css']
})
export class ExitFileUploadComponent implements OnInit, OnChanges {

  docnamePattern = "^[a-zA-Z0-9 ]*$";
  @Input() readonly: boolean;
  @Input() exitType: string;
  @Input() isExitTeam: boolean;
  @Input() model: ExitRequest;
  @Input() showingFileUpload = false;
  @Input() moduleType = ExitDocTypes.REQUESTER_DOC;

  @ViewChild('fileField') element: ElementRef;
  @ViewChild('fileControl') fileEle: ElementRef;

  @ViewChild('f') form: NgForm;
  documentList: DocumentType[] = [];
  documentInstructions: DocumentInstructions[] = [];
  distinctDocTypes: DocumentType[];
  fileDetails: ExitDocument;
  allFiles: ExitDocument[] = [];
  selectedDocument: File;
  disableUpload = false;
  editMode = false;
  showUpload = true;
  docName: string;
  docInstruction: string;
  docType: string;
  showSpinner = false;
  ableToSync = true;
  cicpavisa = false;
  isEmiratesID = false;

  readonly UaeAllowedMimeTypes: string[] = [
    'image/jpeg',
    'image/jpg'
  ];

  readonly allowedMimeTypes = [
    'application/pdf'
    , 'image/jpeg'
    , 'image/png'
    , 'application/msword'
    , 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    , 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    , 'application/vnd.ms-excel'
  ];

  readonly MAX_FILE_SIZE: number = 10 * 1024 * 1024;
  readonly MIN_FILE_SIZE: number = 1 * 1024;

  @Output() GetDocumentEvent = new EventEmitter<ExitDocument[]>();
  @Output() validDocuments = new EventEmitter<LookupField[]>();

  miscellaneous = 'miscellaneous';

  emailShare: GeneralMail = new GeneralMail();
  attachmentShared = [];
  constructor(
    private common: CommonService,
    private fileUploadService: DocumentUploadService,
    private route: ActivatedRoute,
    private toast: ToastService,
    public authService: AuthService,
    private dialog: DialogService,
    private openfilepreview: OpenFilePreviewService,
    private loader: LoaderService,
    private ImmigrationDataPopulation: ImmigrationDataPopulationService,
    private exitApi: ExitApi,
    private emailAPI: EmailApi,
    public modal: NgbActiveModal,
    private shareDocService: ShareDocumentService
  ) {
    this.fileDetails = new CandidateDocuments();
    this.fileDetails.documentTypeId = null;
    this.fileDetails.documentNameId = null;
  }


  ngOnChanges() {
    if (this.model.id > 0
      && this.showingFileUpload) {
      this.getDocumentTypes();
      this.getUploadedFileDetails(this.model.id);
      //this.getDocumentInstructions();
    }
  }

  ngOnInit() {
    if (this.moduleType !== ExitDocTypes.EXIT) {
      this.docType = "Download Exit documents";
    } else {
      this.docType = "Download all";
    }

    // this.getDocumentTypes();
    this.route.params.subscribe(data => {
      if (data.id && data.id > 0) {
        this.common.immigrationProfileId = data.id;
        this.common.exitProfileId = data.id;
        this.getUploadedFileDetails(data.id);
        this.GetDocumentEvent.emit(this.uploadedFiles);
        // this.ableToSync = !this.isVisaApprover;
      }
    });
  }
  downloadEmiratesID() { }
  getDocumentTypes() {
    this.exitApi.getEligibleDocuments(this.exitType, this.moduleType, this.model)
      .subscribe(resp => {
        this.documentList = resp.sort((x, y) => (x.isMandatory === y.isMandatory) ? 0 : x.isMandatory ? -1 : 1);
        this.validDocuments.emit(this.documentList);
      });
  }
  getDocumentInstructions() {
    this.common.GetDocumentInstructions()
      .subscribe(resp => {
        this.documentInstructions = resp;
      });
  }

  share(details: ExitDocument) {
    this.loader.show();
    this.attachmentShared = [];
    const dName = details.fileName.split(".");
    details.fileName = details.documentName.replace("GPN_", '') + "." + dName[dName.length - 1];
    this.attachmentShared.push(details);
    this.emailAPI.getEmailMessageByCode("ShareDocument-Ext").pipe(finalize(() => {
      this.loader.clear();
    })).subscribe(em => {
      this.emailShare = this.shareDocService.mapToGeneralMail(em);
      this.emailShare.subject = "Document: " + details.documentType.displayText;
      this.emailShare.uploadedFiles = this.attachmentShared;
      this.dialog.docShareMail(this.emailShare, (email) => {
        email.activityTemplateId = em.activityTemplateId;
        this.shareDocService.confirmModal(email, ModuleTypes.Exit);
      }, "Share Documents", ModuleTypes.Exit, true);
    });
  }
 
  multipleDocsShare() {
    if (this.moduleType !== ExitDocTypes.EXIT) {
      this.attachmentShared = this.shareDocService.changeDocumentName(this.uploadedFiles, ModuleTypes.Exit);
      if (!this.shareDocService.isFileAvailable(this.attachmentShared)) {
        return;
      }
      this.multiDocShareFn();
    } else {
      this.exitApi.getAllDocumentDetails(this.common.immigrationProfileId)
        .subscribe(resp => {
          if (!this.shareDocService.isFileAvailable(resp)) {
            return;
          }
          resp = this.shareDocService.changeDocumentName(resp, ModuleTypes.Exit);
          this.attachmentShared = resp;
          this.multiDocShareFn();
        });
    }
  }

  multiDocShareFn() {
    this.loader.show();
    this.emailAPI.getEmailMessageByCode("ShareDocument-Ext").pipe(finalize(() => {
      this.loader.clear();
    })).subscribe(em => {
      this.emailShare = this.shareDocService.mapToGeneralMail(em);
      this.emailShare.uploadedFiles = [];
      this.dialog.docShareMail(this.emailShare, (email) => {
        email.activityTemplateId = em.activityTemplateId;
        this.shareDocService.confirmModal(email, ModuleTypes.Exit);
      }, "Share Documents", ModuleTypes.Exit, false, this.attachmentShared);
    });
  }

  
  replaceGPNwithCode(docName:string){ 
    let docN = docName && docName.indexOf("GPN_") > -1 ?
      docName.replace("GPN", "CC+GUI") : `${"CC+GUI"}_${docName}`
    return docN;
  }
  getUploadedFileDetails(id: number) {
    this.allFiles = [];
    this.exitApi.getDocumentDetails(id, this.moduleType).subscribe(resp => {
      this.allFiles = resp;
      this.GetDocumentEvent.emit(this.uploadedFiles);
    });
  }

  changeDocumentName(docs: ImmigrationDocument[]): void {
    docs.forEach(doc => { doc.documentName = this.getDocName(doc.documentName) });
  }

  get getdistinctDocTypes(): DocumentType[] {
    this.distinctDocTypes = [];
    if (this.documentList && this.documentList.length > 0) {
      this.distinctDocTypes = this.documentList.filter(
        (docType, i, arr) => arr.findIndex(t => t.docTypeId === docType.docTypeId) === i);
    }
    return this.distinctDocTypes;
  }

  get documentTypes() {
    if (!this.documentList.length) { return [] }

    return this.documentList.filter(doc => doc.docTypeId === +this.fileDetails.documentTypeId);
  }

  get uploadedFiles(): Array<CandidateDocuments> {
    return this.allFiles;
  }

  get ifDocNotValid(): boolean {
    if (this.selectedDocument && (this.selectedDocument.size < this.MIN_FILE_SIZE || this.selectedDocument.size > this.MAX_FILE_SIZE)) {
      return true;
    }
    return false;
  }

  browseFile() {
    this.fileEle.nativeElement.click();
  }

  get fileBrowserAllowedTypes() {
    // if (this.countryType === CountryTypesValues.UAE) {
    //   return this.UaeAllowedMimeTypes.join(',');
    // } else {
    return this.allowedMimeTypes.join(',');
    // }
  }

  getDocName(docName: string) {
    if (!this.model.docPrefix) {
      return docName.replace("GPN_", '');
    }
    let docN = docName && docName.indexOf("GPN_") > -1 ?
      docName.replace("GPN", this.model.docPrefix) : `${this.model.docPrefix}_${docName}`;
    return docN;
  }

  fileSelected(files: FileList) {
    if (!files.item(0)) {
      return;
    }
    this.selectedDocument = files.item(0);

    if (this.selectedDocument.size < this.MIN_FILE_SIZE || this.selectedDocument.size > this.MAX_FILE_SIZE) {
      this.toast.error(`Invalid file size. File size should be between ${(this.MIN_FILE_SIZE / 1024).toFixed()} KB and ${(this.MAX_FILE_SIZE / 1024 / 1024).toFixed()} MB`);
      this.fileEle.nativeElement.value = null;
      return;
    }
    if (this.allowedMimeTypes.indexOf(this.selectedDocument.type) < 0) {
      this.toast.error(`Invalid file type. Please select a valid file`);
      this.fileEle.nativeElement.value = null;
      this.selectedDocument = null;
      this.element.nativeElement.value = "";
      return;
    }

    this.fileDetails.fileName = this.selectedDocument.name;
  }

  get selectedFileName(): string {
    return nullSafe(() => this.selectedDocument.name, '');
  }

  uploadDoc(f: NgForm) {

    if (f.invalid) {
      return;
    }

    // if (this.countryType === CountryTypesValues.UAE && this.UaeAllowedMimeTypes.includes(this.selectedDocument.type) === false) {
    //   this.toast.error(`Please upload JPEG/JPG files only`);
    //   return;
    // }

    if (this.ifDocNotValid) {
      this.toast.error(`Invalid file size. File size should be between
       ${(this.MIN_FILE_SIZE / 1024).toFixed()} KB and ${(this.MAX_FILE_SIZE / 1024 / 1024).toFixed()} MB`);
      return;
    }
    if (!this.editMode && isNullOrUndefined(this.selectedDocument)) {
      this.toast.warning("Please select a file!");
      return;
    }

    if (!this.editMode) {
      this.fileDetails.id = -1;
      this.fileDetails.createdById = this.authService.ActiveUser.employeeId;
    } else {
      this.fileDetails.modifiedById = this.authService.ActiveUser.employeeId;
    }

    this.upload(f);
  }

  upload(f: NgForm) {
    f.form.disable();
    this.fileDetails.exitRequestId = this.model.id;
    this.fileDetails.description = this.fileDetails.description ? this.fileDetails.description : '';
    this.fileDetails.type = this.moduleType;
    this.disableUpload = true;
    this.fileUploadService.postExitFile(this.fileDetails, this.selectedDocument).pipe(finalize(() => {
      this.disableUpload = false;
      f.form.enable();
    }))
      .subscribe(resp => {
        this.updateAllFiles(resp.data);
        this.element.nativeElement.value = "";
        this.editMode = false;
        if (this.selectedDocument) {
          this.toast.success("File uploaded successfully!");
        } else {
          this.toast.success("Document details updated successfully!");
        }
        this.clear(f);       
        this.getUploadedFileDetails(this.model.id);
      }, error => {
        this.toast.error("Something went wrong!");
      });
    this.GetDocumentEvent.emit(this.uploadedFiles);
  }

  updateAllFiles(resp: ExitDocument) {
    // resp.documentType.lookupTypeId = this.lookupType;
    if (this.editMode) {
      this.allFiles.splice(this.allFiles.findIndex(file => file.id === resp.id), 1, resp);
    } else {
      this.allFiles.push(resp);
    }
  }

  clear(f: NgForm) {
    f.resetForm();
    this.fileDetails.init({ documentTypeId: null, documentNameId: null });
    this.selectedDocument = null;
    this.fileEle.nativeElement.value = null;
    this.editMode = false;
    this.docInstruction = null;
  }

  downloadDocument(details: ExitDocument) {
    const filename = '';
    const doc = new ExitDocument(details);
    doc.documentName = this.getDocName(details.documentName);
    this.fileUploadService.downloadExitFile(doc, filename).subscribe(resp => {
      const extension = this.common.getFileExtension(doc.fileName);
      saveAs(resp, `${doc.documentName}${extension}`);
    },
      error => {
        Logger.error(error);
      });
  }

  downloadAll() {


    if (this.showSpinner) {
      return;
    }

    let typeId = -1;

    if (this.uploadedFiles.length <= 0) {
      this.toast.warning("No files to download!");
      return;
    }
    if (this.moduleType !== ExitDocTypes.EXIT) {
      typeId = this.moduleType;
    }
    this.showSpinner = true;
    this.fileUploadService.downloadAllExit(this.model.id, typeId).pipe(finalize(() => {
      this.showSpinner = false;
    })).subscribe(resp => {
      const gpn = !isNullOrUndefined(this.model.gpn) && this.model.gpn.length > 0 ? this.model.gpn : '';

      const filenames: string[] = [gpn, this.model.firstName, this.model.lastName];
      const filename = filenames.filter(name => name !== '' && name !== null && name !== undefined).join('_');

      saveAs(resp, `${filename}.zip`);
    }, err => {
      Logger.error(err);
    });
  }

  edit(fileDetails, f: NgForm) {
    if (!this.editMode) {
      this.selectedDocument = null;
      this.fileEle.nativeElement.value = null;
    }
    this.editMode = true;

    this.fileDetails.id = fileDetails.id;
    this.fileDetails.documentName = fileDetails.documentName;
    this.fileDetails.description = fileDetails.description;
    this.fileDetails.documentTypeId = fileDetails.documentType.id;
    this.fileDetails.fileName = fileDetails.fileName;
    this.fileDetails.fileGuiId = fileDetails.fileGuiId;
    this.fileDetails.exitRequestId = fileDetails.exitRequestId;
    this.fileDetails.createdById = fileDetails.createdById;
    this.fileDetails.documentNameId = fileDetails.documentNameId;
    this.fileDetails.type = this.moduleType;
    this.setCMDocInstruction();
  }

  delete(fileDetails) {
    this.dialog.showConfirmationBox('Confirm delete',
      'Are you sure you want to delete this file?',
      () => {
        this.exitApi.deleteFile(fileDetails).subscribe((resp) => {
          if (resp) {
            this.toast.success("Document deleted!");
          } else {
            this.toast.error("Document deletion failed!");
          }
          this.getUploadedFileDetails(this.model.id);
        });
      });

  }


  preview(details: ImmigrationDocument) {

    this.openfilepreview.getFilePreviewToken(details).then(token => {
      this.tryOpenInNativeApp(token, details);
    }).catch(err => {
    });
  }

  setCMDocTypes() {
    this.fileDetails.documentNameId = null;
    this.docInstruction = null;
    const filteredVals = this.documentList.filter(t => t.docTypeId === this.fileDetails.documentTypeId);
    if (filteredVals.length === 1) {
      this.fileDetails.documentNameId = filteredVals[0].docNameId;
      this.setCMDocInstruction();
    }
  }

  setCMDocInstruction() {
    this.docInstruction = null;
    this.docInstruction =  nullSafe(() => this.documentInstructions.filter(t => t.docNameId === this.fileDetails.documentNameId)[0].documentInstruction, '');
  }

  tryOpenInNativeApp(token: string, details: CandidateDocuments) {
    const extension: string = details.fileName.split('.').pop();
    const doc = this.getDocName(details.documentName)
    this.docName = `${doc}.${extension}`;
    this.openfilepreview.previewFile(token, details.fileGuiId, this.docName).catch(r => {
      if (extension.toLowerCase() === 'pdf') {
        this.previewPDFFile(token, details);
      } else if (['png', 'jpg', 'jpeg'].indexOf(extension.toLowerCase()) > -1) {
        this.previewImageFile(token, details);
      }
    });
  }

  previewPDFFile(token: string, details: CandidateDocuments) {
    this.dialog.showPDFPreviewiew(this.openfilepreview.constructPDFUrl(token, this.docName), this.docName);
    // window.open(this.openfilepreview.constructPDFUrl(token, this.docName), '_blank');
  }

  previewImageFile(token: string, details: CandidateDocuments) {
    this.dialog.showImagePreview(this.openfilepreview.constructPDFUrl(token, this.docName), this.docName);
    // window.open(this.openfilepreview.constructPDFUrl(token, this.docName), '_blank');
  }

  get canAutoUpload(): boolean {
    return false;
  }

  pullDocsFromEmployeProfile() {

  }

  unlink(document: ImmigrationDocument) {
    // this.loader.show();
    // this.immigrationDatapull.unlinkSyncedImmigrationFile(document).pipe(
    //   finalize(() =>
    //     this.loader.clear()
    //   )
    // ).subscribe(resp => {
    //   this.getUploadedFileDetails(this.model.id);
    // }, err => this.toast.error('Error unlinking the document. Please try again'));

  }

  getDataTrim(data: DocumentType, length: number): string {
    const str = data.docTypeDisplayText;
    const isMandatory = (data.isMandatory || data.mandatoryType > 0) ? true : false;
    return textEllipsis(str, length, { isMandatory });
  }
}

